<template>
    <LayoutTopBar v-if="topBarUSPs && topBarColor" :data="topBarUSPs" :color="topBarColor" />
    <LayoutHeader :data="content?.config" :navigation="navigation" />
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import type { ComputedRef } from 'vue'

const props = defineProps<{
    content: Schemas['CmsElementA4gHeader']
}>()

const navigation = inject<ComputedRef<Schemas['NavigationRouteResponse'] | undefined>>('mainNavigation')

const topBarUSPs = computed(() => {
    return props.content.config?.topBarUSPs?.value
})

const topBarColor = computed(() => {
    return props.content.config?.topBarColor?.value
})
</script>
